import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Capacitor } from '@capacitor/core'
import { changeCurrentThemeSelected } from 'store/modules/theme/actions'

import DesktopView from './Desktop.view'
import MobileView from './Mobile.view'

function ThemeSwitcher() {
  const dispatch = useDispatch()
  const currentThemeSelected = useSelector(
    state => state.theme.currentThemeSelected
  )

  const updateTheme = newTheme => dispatch(changeCurrentThemeSelected(newTheme))

  if (Capacitor.isNativePlatform() || window._env_?.CAPACITOR_DEBUG) {
    return <MobileView theme={currentThemeSelected} toggleTheme={updateTheme} />
  }

  return <DesktopView theme={currentThemeSelected} toggleTheme={updateTheme} />
}

export default ThemeSwitcher
